import { AutoCompleteOption } from "../components/form/APAutoComplete";
import { BankAccount } from "./Contact";
import { PaginationResponse } from "./Pagination";

export type ExpenseClaimType =
  | "fuel"
  | "servicing"
  | "tyres"
  | "rego"
  | "insurance"
  | "charging";

export type ExpenseClaimChargingType = "home" | "public";

export type ExpenseClaimStatus =
  | "awaiting-approval"
  | "approved"
  | "ready-for-payment"
  | "payment-submitted"
  | "paid"
  | "declined"
  | "cancelled";

export type ExpenseClaimReviewStatus = "valid" | "declined" | "cancelled";

export type ExpenseClaim = {
  id: string;
  dossierId: string;
  transactionId: string | null;
  type: ExpenseClaimType;
  status: ExpenseClaimStatus;
  reviewStatus: ExpenseClaimReviewStatus | null;
  vendor: string | null;
  description: string;
  noteToDriver: string | null;
  incGst: number;
  exGst: number;
  odometer: number | null;
  transactionDate: string;
  createdDate: string;
  estimatedPaymentDate: string | null;
  reviewedDate: string | null;
  submittedForPaymentDate: string | null;
  paymentEtaText: string | null;
  paidDate: string | null;
  taxInvoiceName: string | null;
  taxInvoiceId: string | null;
  attachmentName: string | null;
  attachmentId: string | null;
  bank: BankAccount | null;
};

export type ExpenseClaimPaginationList = PaginationResponse<ExpenseClaim>;

export const ExpenseClaimLabelMap: Record<ExpenseClaimType, string> = {
  fuel: "Fuel / Charging",
  servicing: "Service",
  tyres: "Tyres",
  rego: "Rego / CTP",
  insurance: "Insurance",
  charging: "Charging",
};

export const ExpenseClaimTypeOptions: AutoCompleteOption[] = [
  { label: ExpenseClaimLabelMap.fuel, id: "fuel" },
  { label: ExpenseClaimLabelMap.servicing, id: "servicing" },
  { label: ExpenseClaimLabelMap.tyres, id: "tyres" },
  { label: ExpenseClaimLabelMap.rego, id: "rego" },
  { label: ExpenseClaimLabelMap.insurance, id: "insurance" },
];

export const SubmittedExpenseClaimTypeOptions: AutoCompleteOption[] = [
  { label: "Fuel", id: "fuel" },
  { label: "Charging", id: "charging" },
  ...ExpenseClaimTypeOptions.slice(1),
];

export const ExpenseClaimChargingTypeOptions: AutoCompleteOption[] = [
  { label: "Home Charging", id: "home-charging" },
  { label: "Public Charging", id: "public-charging" },
];

export type ReceiptData = {
  ocrRequestId: string;
  vendor?: string;
  description?: string;
  incGst?: number;
  exGst?: number;
  transactionDate?: string;
};
